// The screens and their titles. Titles live here (not in each page) because the top bar shows them.

export const PAGE_TITLES: Record<string, string> = {
  '': 'Dashboard',
  calendar: 'Team calendar',
  year: 'My year',
  'org-chart': 'Org chart',
  approvals: 'Approvals',
  admin: 'Admin',
};

/** The title for a path like "/admin/people". Unknown paths show the dashboard's. */
export function titleFor(pathname: string): string {
  const first = pathname.split('/')[1] ?? '';
  return Object.hasOwn(PAGE_TITLES, first) ? PAGE_TITLES[first]! : PAGE_TITLES['']!;
}
